/**
 * Utilitaires pour gérer les contenus multilingues
 */

/**
 * Récupère la valeur traduite d'un champ selon la langue sélectionnée
 * @param {Object} item - L'objet contenant les champs traduits (exercice, leçon, etc.)
 * @param {string} fieldName - Le nom du champ de base (ex: 'question', 'title', 'options')
 * @param {string} language - Le code de langue ('fr', 'en', 'es', 'de', 'it', 'ar')
 * @returns {any} La valeur dans la langue demandée, ou en français par défaut
 */
export const getTranslatedField = (item, fieldName, language) => {
  if (!item) return '';
  
  // Si la langue est le français ou n'est pas spécifiée, retourner le champ de base
  if (!language || language === 'fr') {
    return item[fieldName];
  }
  
  // Construire le nom du champ traduit (ex: 'question_en', 'options_es')
  const translatedFieldName = `${fieldName}_${language}`;
  
  // Retourner le champ traduit s'il existe, sinon le champ français par défaut
  return item[translatedFieldName] || item[fieldName];
};

/**
 * Récupère un exercice avec tous ses champs traduits selon la langue
 * @param {Object} exercise - L'exercice brut de l'API
 * @param {string} language - Le code de langue
 * @returns {Object} L'exercice avec les champs dans la bonne langue
 */
export const getLocalizedExercise = (exercise, language) => {
  if (!exercise) return null;
  
  return {
    ...exercise,
    question: getTranslatedField(exercise, 'question', language),
    options: getTranslatedField(exercise, 'options', language),
    correct_answer: getTranslatedField(exercise, 'correct_answer', language),
    explanation: getTranslatedField(exercise, 'explanation', language),
  };
};

/**
 * Récupère une leçon avec ses champs traduits selon la langue
 * @param {Object} lesson - La leçon brute de l'API
 * @param {string} language - Le code de langue
 * @returns {Object} La leçon avec les champs dans la bonne langue
 */
export const getLocalizedLesson = (lesson, language) => {
  if (!lesson) return null;
  
  return {
    ...lesson,
    title: getTranslatedField(lesson, 'title', language),
    description: getTranslatedField(lesson, 'description', language),
    educational_content: getTranslatedField(lesson, 'educational_content', language),
  };
};
